import { render } from "./CalendarContextMenu.vue?vue&type=template&id=9dafb6f0&scoped=true"
import script from "./CalendarContextMenu.vue?vue&type=script&lang=js"
export * from "./CalendarContextMenu.vue?vue&type=script&lang=js"

import "./CalendarContextMenu.vue?vue&type=style&index=0&id=9dafb6f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dafb6f0"]])

export default __exports__